import { useContext } from 'react';
import ProgressContext from './ProgressContext';
import { ProviderContext } from './types';

export default function useProgress():ProviderContext{
  return useContext(ProgressContext)
};